import React from "react";
import { Row, Col } from "react-bootstrap";

import PaperCreate from "../../components/Paper/Create";

const Create = () => {
    return (
        <Row>
            <Col>
                <PaperCreate />
            </Col>
        </Row>
    );
};

export default Create;